import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay, EffectCoverflow } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';

const CommunitySection = () => {
    const images = [
        { 
            src: '/world-autism-day.png', 
            alt: 'World Autism Day', 
            title: 'World Autism Day',
            description: 'Supporting autism awareness and inclusion'
        },
        { 
            src: '/world-ms-day.png', 
            alt: 'World MS Day', 
            title: 'World MS Day',
            description: 'Raising awareness for multiple sclerosis'
        },
        { 
            src: '/international-womens-day.png', 
            alt: 'International Women\'s Day', 
            title: 'International Women\'s Day',
            description: 'Celebrating the achievements of women'
        },
        { 
            src: '/world-ms-day.png', 
            alt: 'World MS Day', 
            title: 'World MS Day',
            description: 'Raising awareness for multiple sclerosis'
        },
        { 
            src: '/international-womens-day.png', 
            alt: 'International Women\'s Day', 
            title: 'International Women\'s Day',
            description: 'Celebrating the achievements of women'
        },
        { 
            src: '/world-autism-day.png', 
            alt: 'World Autism Day', 
            title: 'World Autism Day',
            description: 'Supporting autism awareness and inclusion'
        },
    ];

    return (
        <section className="px-8 py-20 bg-gradient-to-b from-white to-gray-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-5xl font-arial-rounded text-primary font-bold mb-4">
                        Contributions to Our Community
                    </h2>
                    <div className="w-24 h-1 bg-primary-yellow mx-auto mb-6"/>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Making a difference in our community through active participation and support
                    </p>
                </div>

                <div className="relative swiper-container px-8">
                    <Swiper
                        modules={[Navigation, Pagination, A11y, Autoplay, EffectCoverflow]}
                        coverflowEffect={{
                            rotate: 0,
                            stretch: 0,
                            depth: 100,
                            modifier: 2.5,
                            slideShadows: false,
                        }}
                        spaceBetween={30}
                        slidesPerView={1}
                        loop={true}
                        loopFillGroupWithBlank={true}
                        navigation={{
                            nextEl: '.swiper-button-next-custom',
                            prevEl: '.swiper-button-prev-custom',
                        }}
                        pagination={{ 
                            clickable: true,
                            dynamicBullets: true
                        }}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                        }}
                        breakpoints={{
                            768: {
                                slidesPerView: 4,
                                spaceBetween: 30,
                            }
                        }}
                        className="py-10 px-8"
                    >
                        {images.map((image, index) => (
                            <SwiperSlide key={index}>
                                <div className="group relative overflow-hidden shadow-lg transform transition-all duration-300 hover:-translate-y-2">
                                    <div className="aspect-w-4 aspect-h-3">
                                        <img 
                                            src={image.src}
                                            alt={image.alt}
                                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                    </div>
                                    <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                        <h3 className="font-bold text-lg mb-1">{image.title}</h3>
                                        <p className="text-sm opacity-90">{image.description}</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Custom Navigation Buttons */}
                    <button 
                        className="swiper-button-prev-custom absolute top-1/2 -left-4 z-10 w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center transform -translate-y-1/2 transition-all duration-300 hover:bg-secondary-green hover:scale-110 focus:outline-none"
                        aria-label="Previous slide"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <button 
                        className="swiper-button-next-custom absolute top-1/2 -right-4 z-10 w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center transform -translate-y-1/2 transition-all duration-300 hover:bg-secondary-green hover:scale-110 focus:outline-none"
                        aria-label="Next slide"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CommunitySection;
